export enum QuestionnaireStatus {
  PENDING = "pending",
  SUBMITTED = "submitted"
}
